import { clone } from './clone';
import { defkey } from './constants';
import { create } from './create';
import { FieldDefinition, FromDefinition, OptionalDefinition, PkDefinition, SchemaDefinition } from './definition';
import { deserialize } from './deserialize';
import { serialize } from './serialize';

function ensureDefinitions(target: any, key: string) {
	if (!target[defkey]) {
		target[defkey] = {};
	}

	if (!target[defkey][key]) {
		target[defkey][key] = [];
	}
}

function addAttrDefinition(target: any, key: string, definition: any) {
	ensureDefinitions(target, key);
	target[defkey][key].push(definition);
}

export function Field(transformer?: any) {
	return function (target: any, attr: string) {
		addAttrDefinition(target, attr, new FieldDefinition(transformer));
	};
}

export function PrimaryKey() {
	return function (target: any, attr: string) {
		addAttrDefinition(target, attr, new PkDefinition());
	};
}

export function Optional() {
	return function (target: any, attr: string) {
		addAttrDefinition(target, attr, new OptionalDefinition());
	};
}

export function From(name: string) {
	return function (target: any, attr: string) {
		addAttrDefinition(target, attr, new FromDefinition(name));
	};
}

export function Schema() {
	return function (target: any) {
		const def = new SchemaDefinition(target.name, target.prototype[defkey]);

		if (!def.isValid()) {
			throw new Error(`Invalid schema definition for ${target.name}:\n` + def.errors.join('\n'));
		}

		Object.assign(target, { [defkey]: def });
		delete target.prototype[defkey];
	};
}

// We can't call the function `new` because it's a reserved keyword in JavaScript. I don't want to call it `create()` on the schema since we're not
// actually making records, we're just creating instances of the schema.
Schema.new = create;
Schema.clone = clone;
Schema.deserialize = deserialize;
Schema.serialize = serialize;
